function scrolling(event) {
  event.preventDefault();

  document.querySelector(event.target.hash).scrollIntoView({
    behavior: "smooth"
  });
  event.target.attr('tabindex', '-1');
  event.target.focus();
}

export default scrolling;



// WEBPACK FOOTER //
// ./src/components/utils/animation/scrolling.js